import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 8.00391V6H6.00391V6.00391H6V8.00391H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 13.0039V11H6.00391V11.0039H6V13.0039H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 18.0039V16H6.00391V16.0039H6V18.0039H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 2H2V22H17V16H22V10H12V2ZM10 4V20H4V4H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18H19V22H22V18Z"}}]};

const City1Filled = Vue.extend<IconProps>({
  name: 'City1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default City1Filled;
